// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3vKeJ","imageUploader":"EGiftCard_imageUploader__MApJ6"};